import superagent from 'superagent';
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';

export const fetchShortArticleNumber = createAsyncThunk(
	'shortArticleNumber/shortArticleNumberLoading',
	(options, {getState}) =>
		superagent
			.post(`${getState().status.shortArticleNumberUrl}/shortArticleNumber/getOrCreate?productFamilyId=${getState().status.productFamily}&productModelId=${getState().configuration.data.projects[0].project.productModelId}`)
			.send(options)
			.set('X-API-KEY', 'DzQ9No1SX1SPSop56uG6LGV662oZ4M9AQ81kLDSMV0yrtuM80UGnlv-aSf3r') // TODO replace with proxy
			.set('Accept', 'application/json')
			.then((response) => response.body)
			.catch((error) => error)
);

const shortArticleNumberInitialState = {
	status: 'idle',
	data: '',
	error: {},
};
export const shortArticleNumberSlice = createSlice({
	name: 'shortArticleNumber',
	initialState: shortArticleNumberInitialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(fetchShortArticleNumber.fulfilled, (state, action) => {
			state.data = action.payload;
			state.status = 'idle';
			state.error = {};
		});
		builder.addCase(fetchShortArticleNumber.pending, (state, action) => {
			state.status = 'loading';
			state.error = {};
		});
		builder.addCase(fetchShortArticleNumber.rejected, (state, action) => {
			state.data = {};
			state.status = 'idle';
			state.error = action.payload;
		});
	}
});


export const {} = shortArticleNumberSlice.actions;


export default shortArticleNumberSlice.reducer;
